<div class="media-team-links-wrapper">
	@for (team of sortedTeams; track team) {
		<a class="theme-header-txt media-team-link text-hover-none" [uiSref]="PORTAL_MEDIA_STATE" [uiParams]="{team: team.id}" [title]="team.name" [uiOptions]="{inherit:false}">
			<span class="media-team-link-logo" [ngStyle]="{'background-color': team.logoImageUri ? 'transparent': team.bgColor	}">
				@if (team.logoImageUri) {
					<img class="team-thumbnail" [src]="team.logoImageUri" [alt]="'ThumbnailForAria' | translate : { '0': team.name }" (error)="team.logoImageUri = undefined" vbImageLoad/>
				}@else {
					<div class="default-team-logo">
						<span class="vb-icon vb-icon-center vb-icon-videos"></span>
					</div>
				}
			</span>
			<span class="media-team-label" [ngClass]="{'media-team-link-name': !team.logoImageUri }">
				{{ team.name }}
			</span>
		</a>
	}
</div>
